import React from 'react'
import sortAsc from '../../../images/sort-asc.svg'
import sortDes from '../../../images/sort-des.svg'

interface SortFilter<T> {
	column: keyof T | string
	order: 'ASC' | 'DSC'
}

interface SortButtonProps<T> {
	setSort: React.Dispatch<React.SetStateAction<SortFilter<T>>>
	sort: SortFilter<T>
	columnName: keyof T | string
	preIconContent?: React.ReactNode
	sortJustify?: 'start' | 'end'
}

const SortButton = <T,>(props: SortButtonProps<T>) => {
	const setSortOrder = (column: keyof T | string) => {
		if (column !== props.sort.column) {
			props.setSort({ column, order: 'ASC' })
		} else {
			props.setSort({ column, order: props.sort.order === 'ASC' ? 'DSC' : 'ASC' })
		}
	}

	const columnSelected = props.sort.column === props.columnName
	const imgSrc = (props.sort.column === props.columnName && props.sort.order === 'ASC') || props.sort.column !== props.columnName ? sortAsc : sortDes
	const altText = `A sort ${(columnSelected && props.sort.order === 'ASC') || props.sort.column !== props.columnName ? 'ascending' : 'descending'} icon`
	const className = columnSelected ? 'table-sort-active' : ''

	return (
		<div className="sort-table-btn" onClick={() => setSortOrder(props.columnName)}>
			<div className={`d-flex align-items-center mb-2 ${props.sortJustify ? 'justify-content-' + props.sortJustify : ''}`} id={'icon'}>
				{props.preIconContent}
				<img src={imgSrc} alt={altText} className={className} />
			</div>
		</div>
	)
}

export { SortButton }
export type { SortFilter, SortButtonProps }
